import { RULE_TYPE } from 'fela-utils';

import renderToSheetList from '../../server/renderToSheetList';

// This method is quite hacky and in-performant, but yet
// the most simple way to respect rule sorting even in devMode
export default function updateNodeInDevMode(renderer, node) {
  var sheetList = renderToSheetList(renderer);

  var media = node.getAttribute('media') || undefined;
  var support = node.getAttribute('data-fela-support') || undefined;

  var currentSheet = sheetList.find(function (sheet) {
    return sheet.type === RULE_TYPE && sheet.media === media && sheet.support === support;
  });

  if (currentSheet) {
    node.textContent = currentSheet.css;
  }
}